import { IEntity } from "src/app/core/interfaces";
import { SecureFileStateObject } from "./secure-file-model";

export interface SecureFileStateModel {
  entities: IEntity[];
  stateObject: SecureFileStateObject;
  isEntityLoading: boolean;
  isEntityOwnersLoading: boolean;
  isEntityProgressLoading: boolean;
}

export const initialState: SecureFileStateModel = {
  entities: [],
  stateObject: new SecureFileStateObject(),
  isEntityLoading: false,
  isEntityOwnersLoading: false,
  isEntityProgressLoading: false,
};
